import { combineReducers } from 'redux'
import { i18nState } from 'redux-i18n'

import { reducer as routingReducer } from '../lib/routing'

import { appReducer } from './app'
import { agentReducer } from './agent'
import { loginReducer } from './login'
import { routerReducer } from './router'
import { wssReducer } from './wss'
import { signalingReducer } from './signaling'
import { webrtcConnectionReducer } from './webrtcConnection'
import { toolbarReducer } from './toolbar'
import { disconnectReducer } from './disconnect'
import { ondemandReducer } from './ondemand'
import { audioReducer } from './audio'
import { mediaDevicesReducer } from './mediaDevices'
import { featuresReducer } from './features'
import { clipboardReducer } from './clipboard'

export default combineReducers({
  app: appReducer,
  agent: agentReducer,
  login: loginReducer,
  router: routerReducer,
  location: routingReducer,
  wss: wssReducer,
  signaling: signalingReducer,
  webrtcConnection: webrtcConnectionReducer,
  toolbar: toolbarReducer,
  disconnect: disconnectReducer,
  ondemand: ondemandReducer,
  audio: audioReducer,
  mediaDevices: mediaDevicesReducer,
  features: featuresReducer,
  clipboard: clipboardReducer,
  i18nState
})
